module.exports = __webpack_public_path__ + "static/Giselle-4c6ce87bc43f9ff2efeb5e0b7e4e58ea.png";